var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineSearchFavorite2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.5c0-5.65 4.6-10.25 10.25-10.25.41 0 .75.34.75.75s-.34.75-.75.75c-4.83 0-8.75 3.93-8.75 8.75s3.92 8.75 8.75 8.75 8.75-3.93 8.75-8.75c0-.41.34-.75.75-.75s.75.34.75.75c0 5.65-4.6 10.25-10.25 10.25S1.25 17.15 1.25 11.5zM21.47 22.53l-2-2a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.78 6.36c-.45-1.41.07-3.26 1.7-3.79.7-.23 1.43-.12 2.01.25.57-.37 1.32-.47 2.02-.25 1.63.53 2.16 2.38 1.7 3.79-.65 2.1-2.9 3.18-3.71 3.18-.92 0-3.06-1.12-3.72-3.18zm3.73 1.69c.32-.03 1.85-.77 2.27-2.13.23-.73 0-1.67-.73-1.91-.31-.1-.73-.04-.93.25-.14.21-.36.33-.61.34a.758.758 0 0 1-.62-.31c-.23-.33-.65-.38-.95-.29-.72.24-.96 1.18-.73 1.91.46 1.45 2.02 2.11 2.3 2.14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSearchFavorite2);
export default __webpack_public_path__ + "static/media/vuesax-outline-search-favorite-2.5d7e98cab56f37827969fd2af8a83c4e.svg";
export { ForwardRef as ReactComponent };